module.exports = "img/5.c8fd20.webp";